import getCustomerGroupRequest from '@domain/model/request/customerGroup/getCustomerGroupRequest';
import getCustomerGroup from '@hooks/customerGroup/getCustomerGroup';
import getCustomerGroupResponse from '@domain/model/response/customerGroup/getCustomerGroupResponse';

export const useGetCustomerGroup = ({ enabled = false, groupType, custGroup }) => {
    const queries = getCustomerGroupRequest({ groupType, custGroup });
    const responses = getCustomerGroup({ enabled, queries });
    const mappingResult = getCustomerGroupResponse(responses?.data);
    return { ...responses, data: mappingResult };
};
